import Pure from '@rebuild/materials/modules/slide/announcement/v1/overview.vue';
import MobPure from './mob-pure.vue';

export const componentMap = {
	pure: Pure,
	'mob-pure': MobPure
};
